import IdHelper from "./IdHelper";
export default IdHelper;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/utils/IdHelper/index.tsx